// eslint-disable-next-line import/prefer-default-export
export const applyGeneralError = (hasError, values, setErrors) => {
  if (!hasError || !values) return false

  const newValues = {}

  Object.keys(values).forEach((key) => {
    newValues[key] = ''
  })

  setErrors(newValues)

  return newValues
}
